import { flow } from 'fp-ts/function';
import { ApplicationState } from '@mews-commander/types';
import { Slot } from '@mews-commander/resources';
import { createAction } from '@mews/framework';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'resourceSlots';

export const RESOURCE_SLOTS_UPDATED = prefix('RESOURCE_SLOTS_UPDATED');

export const setResourceSlots = (slots: Slot[]) => createAction(RESOURCE_SLOTS_UPDATED, slots);

export const resourceSlotsReducer = createEntitiesReducer({
    UPDATE_SUCCESS: RESOURCE_SLOTS_UPDATED,
});

export const [getSlots, getSlotsByIds, getSlotsByOwnerId, getSlot] = createBaseEntitySelectors<
    ApplicationState,
    Slot,
    typeof NAME
>(parentSelector, NAME);

export const getSlotResourceCategoryId = flow(getSlot, (slot) => slot?.categoryId);
